module.exports = __webpack_public_path__ + "img/sentiment_very_satisfied.dd9afbdc.svg";